// extracted by mini-css-extract-plugin
export default {"leftBarItem":"xDO4k2EgjE75KSOffVMy","leftBarFooterItem":"XF8FQdIul8Q77OGrHmvu"};